import {useMemo} from 'react';
import type {BreadcrumbAtomPropTypes} from '@sdb/ui/types/components/atoms/Breadcrumb.types';
import type {NavigationRailMenuDataItem} from '@sdb/ui/types/components/molecules/NavigationRail/NavigationRail.types';

export const useBreadcrumbs = (
    navData: NavigationRailMenuDataItem[],
    selectedId: string | undefined,
) => {
    return useMemo(() => {
        const rslt = [] as BreadcrumbAtomPropTypes[];

        if (navData && navData.length) {
            navData.forEach((value, index) => {
                const childSelected = value.submenu?.find(
                    (x: {id: string | undefined}) => x.id === selectedId,
                );

                if (index === 0 || value.id === selectedId || childSelected) {
                    const path = value.href || undefined;

                    rslt.push({label: value.label?.toString() ?? '', path: path});
                }

                if (childSelected) {
                    rslt.push({
                        label: childSelected?.label?.toString() ?? '',
                        path: childSelected.href,
                    });
                }
            });
        }

        return rslt;
    }, [navData]);
};
